export default function resolveComment(comment, praiseCount) {
  const reg = /xxxx/i
  const numberReg = /\d{1,3}/g
  let countStr = praiseCount.toString()
  countStr = countStr
    .split("")
    .reverse()
    .join("")
  let countArr = countStr.match(numberReg)
  countArr = countArr
    .join(",")
    .split("")
    .reverse()
  countStr = countArr.join("")
  return comment.replace(reg, countStr)
}
